import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Dropdown,
  Form,
  Input,
  Menu,
  Select,
  Spin,
  Table,
  Tooltip,
} from "antd";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import { getRequest, patchRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import { InfoCircleOutlined } from "@ant-design/icons";

import ButtonField from "../../common/htmlComponents/ButtonField";
import Downloadpd from "../../image/Downloadpd.svg";
import Excel from "../../image/excel.png";
import PDF from "../../image/pdf.png";

import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import "jspdf-autotable";
import jsPDF from "jspdf";
import { DownloadTableExcel } from "react-export-table-to-excel";

const ComparativeSiteDiameterWise = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [reload, setReload] = useState(false);
  const [siteName, setSiteName] = useState([]);
  const [materialName, setMaterialName] = useState([]);
  const [enableInputs, setEnableInputs] = useState(false);
  const { id } = useParams();
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [siteDetails, setSiteDetails] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const formRef = useRef();
  const [vendors, setVendors] = useState([]);

  const [loading, setLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const [state, setState] = useState({
    site_names: [],
    city_names: [],
    material_type_names: [],
  });

  const [hideInitialBidPrice, sethideInitialBidPrice] = useState(false);
  const [hideR1BidPrice, setHideR1BidPrice] = useState(false);
  const [hideRBidPrice, setHideRBidPrice] = useState(false);
  const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
  const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
  const [isFinalBidPrice, setIsFinalBidPrice] = useState(false);
  const [showAdditionalCheckboxesFinal, setShowAdditionalCheckboxesFinal] =
    useState(true);
  const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
    useState(false);
  const [comparativesRFQ, setComparativesRFQ] = useState([]);
  const [rfqNumber, setRfqNumber] = useState(null);
  const [buyerName, setBuyerName] = useState(null);
  const [contengency, setContengency] = useState(null);
  const [categoryType, setCategoryType] = useState(null);
  const [response1, setResponse1] = useState([]);
  const [dataSource1, setDataSource] = useState([]);
  const [summaryDataSource, setSummaryDataSource] = useState([]);
  const [showR1, setShowR1] = useState(false);
  const [showR0, setShowR0] = useState(false);
  const [showR, setShowR] = useState(false);
  const [showLPP, setShowLPP] = useState(false);
  const [showGST, setShowGST] = useState(false);
  const tableRef = useRef();
  const hiddenTableRef = useRef();

  const [initialBidDate, setInitialBidDate] = useState(null);
  const [revisedBidDate, setRevisedBidDate] = useState(null);
  const [finalBidDate, setFinalBidDate] = useState(null);

  const [vendorBidDates, setVendorBidDates] = useState({});

  const uniqueVendors = new Set();
  const uniqueVendors2 = new Set();
  const [summaryColumn, setSummaryColumn] = useState([]);

  const summaryRowMeta = {
    A1: { color: "#A3F2EB", label: "A1", desc: "Basic Price" },
    B1: { color: "#CCD5FF", label: "B1", desc: "Commission Charges" },
    C1: { color: "#FFEFA8", label: "C1", desc: "Taxes" },
    D1: {
      color: "#FFD3B3",
      label: "D1",
      desc: "Total Evaluated Price ",
      formula: "[A1] + [B1] + [C1]",
    },
    E1: {
      color: "#FF9E96",
      label: "E1",
      desc: "Contingency @ 2% On ",
      formula: "[D1]",
    },
    F1: {
      color: "#F4B9F4",
      label: "F1",
      desc: "Total Proposed Cost ",
      formula: "[D1] + [E1]",
    },
    H1: { color: "#E1FF97", label: "H1", desc: "Payment Terms" },
    I1: { color: "#ADFFC7", label: "I1", desc: "Payment Security Details" },
    K1: {
      color: "rgb(255 231 231)",
      label: "K1",
      desc: "Commercial Ranking On Total Price ",
      formula: "[D1]",
    },
    L: {
      color: "rgb(255 157 43)",
      label: "L",
      desc: "Average Price/MT - OPC43",
    },
    L1: {
      color: "rgb(225 127 43)",
      label: "L1",
      desc: "Average Price/KG - OPC43",
    },
    M: {
      color: "rgb(155 157 3)",
      label: "M",
      desc: "Average Price/MT - OPC53",
    },
    M1: {
      color: "rgb(255 245 84)",
      label: "M1",
      desc: "Average Price/KG - OPC53",
    },
  };

  const findLatestAvailableRound = (vendorDetail, vendorSubTotals) => {
    if (!vendorDetail) return null;
    const roundPriority = { r: 3, r1: 2, r0: 1 };
    const vendorRounds = vendorSubTotals
      .filter(
        (v) => v.vendor_name === vendorDetail.vendor_name && v.bid_date !== null
      )
      .sort((a, b) => roundPriority[b.round] - roundPriority[a.round]);
    return vendorRounds.length > 0 ? vendorRounds[0].round : null;
  };

  useEffect(() => {
    const getVendorBidRFQ = async () => {
      let vendorBidDates = [];
      setapiLoading(true);
      try {
        const response1 = await patchRequest(
          `comparative-rfq/${id}/get-comparative-details-by-city-wise/`
        );
        setRfqNumber(response1.data.data.rfq_number);
        setBuyerName(response1.data.data.buyer_name);
        setContengency(response1.data.data.contingency_charges);
        if(response1.data.data.is_diameter_wise === false){
          setCategoryType(true);
        } else {
          setCategoryType(false);
        }
        
        setResponse1(response1);
        if (response1.data.data) {
          let dataSource = [];
          let prevCity = "";
          let prevSite = "";
          const uniqueVendors = new Set();
          let vendorBidDatesTemp = {};
          response1.data.data.comparative_details_by_rfq_site_wise.forEach(
            (cityDetail, cityIndex) => {
              let prevSubCategory = "";
              cityDetail.rfq_site_wise_details.forEach(
                (siteDetail, siteIndex) => {
                  siteDetail.rfq_material_wise_details.forEach(
                    (materialDetail, materialIndex) => {
                      const diameterSet = new Set();
                      (materialDetail.vendors || []).forEach((vendor) => {
                        (vendor.diameter_details || []).forEach((dia) => {
                          if (
                            dia.diameter_value !== undefined &&
                            dia.diameter_value !== null
                          ) {
                            diameterSet.add(Number(dia.diameter_value));
                          }
                        });
                        uniqueVendors.add(vendor.vendor_name);
                      });
                      const uniqueDiameters = Array.from(diameterSet).sort(
                        (a, b) => a - b
                      );
                      
                      uniqueDiameters.forEach((diameter, diaIndex) => {
                        
                        const isFirstMaterial = diaIndex === 0;
                        const showCity =
                          isFirstMaterial &&
                          prevCity !== cityDetail.rfq_city_name
                            ? cityDetail.rfq_city_name
                            : "";
                        const showSite =
                          prevSite !== siteDetail.rfq_site_name
                            ? siteDetail.rfq_site_name
                            : "";
                        if (isFirstMaterial)
                          prevCity = cityDetail.rfq_city_name;
                        prevSite = siteDetail.rfq_site_name;
                        const currentSubCategory = materialDetail.rfq_material_type_sub_category || "";
                        const showSubCategory =
                      diaIndex === 0 &&
                      (materialIndex === 0 || currentSubCategory !== prevSubCategory)
                        ? currentSubCategory
                        : "";
                        let rowData = {
                          key: `row-${cityIndex}-${siteIndex}-${materialIndex}-${diaIndex}`,
                          srNo: `${cityIndex + 1}.${siteIndex + 1}`,
                          city: showCity,
                          site: showSite,
                          subCategory: showSubCategory,
                          materialType: isFirstMaterial
                            ? materialDetail.rfq_material_type_name
                            : "",
                          diameter: diameter ? `${diameter} MM` : "",
                          qty: "",
                          uom: isFirstMaterial
                            ? materialDetail.rfq_material_type_uom || ""
                            : "",
                          gst_rate: isFirstMaterial
                            ? materialDetail.gst_rate
                            : "",
                        };
                        const vendorMap = {};
                        (materialDetail.vendors || []).forEach((vendor) => {
                          const key = vendor.vendor_name.toLowerCase().replace(/\s+/g, "");
                          if (!vendorMap[key]) {
                            vendorMap[key] = { ...vendor, diameter_details: [...(vendor.diameter_details || [])] };
                          } else {
                            vendorMap[key].diameter_details = [
                              ...(vendorMap[key].diameter_details || []),
                              ...(vendor.diameter_details || [])
                            ];
                          }
                        });
                        const mergedVendors = Object.values(vendorMap);

                        mergedVendors.forEach((vendor) => {
                          const vendorKey = vendor.vendor_name
                            .toLowerCase()
                            .replace(/\s+/g, "");
                          const diaDetail = (vendor.diameter_details || []).find(
                            (d) => Number(d.diameter_value) === Number(diameter)
                          );
                          const priceObj = diaDetail && 
                            diaDetail.r_price?.[0] ||
                            diaDetail.r1_price?.[0] ||
                            diaDetail.r0_price?.[0] ||
                            {};
                            
                          const priceR0 = diaDetail.r0_price?.[0] || {};
                          const priceR1 = diaDetail.r1_price?.[0] || {};
                          rowData[`${vendorKey}UnitPrice`] =
                            priceObj.r_unit_price !== undefined
                              ? priceObj.r_unit_price.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                })
                              : "N/A";
                          rowData[`${vendorKey}Amount`] =
                            priceObj.r_amount_without_gst !== undefined
                              ? priceObj.r_amount_without_gst.toLocaleString(
                                  "en-IN",
                                  { maximumFractionDigits: 0 }
                                )
                              : "N/A";
                          rowData[`${vendorKey}BidDate`] =
                            priceObj.bid_date || "N/A";
                          rowData[`${vendorKey}UnitPriceR0`] =
                            priceR0.r_unit_price !== undefined
                              ? priceR0.r_unit_price.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                })
                              : "N/A";
                          rowData[`${vendorKey}AmountR0`] =
                            priceR0.r_amount_without_gst !== undefined
                              ? priceR0.r_amount_without_gst.toLocaleString(
                                  "en-IN",
                                  { maximumFractionDigits: 0 }
                                )
                              : "N/A";
                          rowData[`${vendorKey}UnitPriceR1`] =
                            priceR1.r_unit_price !== undefined
                              ? priceR1.r_unit_price.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                })
                              : "N/A";
                          rowData[`${vendorKey}AmountR1`] =
                            priceR1.r_amount_without_gst !== undefined
                              ? priceR1.r_amount_without_gst.toLocaleString(
                                  "en-IN",
                                  { maximumFractionDigits: 0 }
                                )
                              : "N/A";
                          vendorBidDatesTemp[vendorKey] =
                            vendorBidDatesTemp[vendorKey] || {};
                          if (priceObj.bid_date)
                            vendorBidDatesTemp[vendorKey].finalBidDate =
                              priceObj.bid_date || "N/A";
                          if (priceR1.bid_date)
                            vendorBidDatesTemp[vendorKey].revisedBidDate =
                              priceR1.bid_date || "N/A";
                          if (priceR0.bid_date)
                            vendorBidDatesTemp[vendorKey].initialBidDate =
                              priceR0.bid_date || "N/A";
                        });
                        // Set quantity by finding any vendor with the current diameter
                        let foundQty = null;
                        for (const vendor of materialDetail.vendors || []) {
                          const diaDetail = (vendor.diameter_details || []).find(
                            (d) => Number(d.diameter_value) === Number(diameter)
                          );
                          if (diaDetail && diaDetail.diameter_quantity !== undefined && diaDetail.diameter_quantity !== null) {
                            foundQty = diaDetail.diameter_quantity;
                            break;
                          }
                        }
                        rowData.qty = foundQty !== null ? foundQty : "N/A";

                        const priceDetail =
                          (materialDetail.last_purchase_price || [])[0] || {};
                        // --- FIX itemWiseL1 logic ---
                        let itemWiseL1 = "N/A";
                        if (Array.isArray(priceDetail.item_wise_l1)) {
                          const l1Entry = priceDetail.item_wise_l1.find(
                            (l1) => Number(l1.diameter_value) === Number(diameter)
                          );
                          if (l1Entry && l1Entry.lowest_price !== undefined && l1Entry.lowest_price !== null) {
                            itemWiseL1 = l1Entry.lowest_price.toLocaleString("en-IN", { maximumFractionDigits: 0 });
                          }
                        }
                        rowData = {
                          ...rowData,
                          poDate: priceDetail.lpp_po_number_date || "N/A",
                          vendorName: priceDetail.vendor_name || "N/A",
                          unitPrice:
                            priceDetail.unit_price?.toLocaleString("en-IN", {
                              maximumFractionDigits: 0,
                            }) || "N/A",
                          avgPrice:
                            priceDetail["30_days_avg_price"]?.toLocaleString(
                              "en-IN",
                              { maximumFractionDigits: 0 }
                            ) || "N/A",
                          itemWiseL1, // <-- use the fixed value
                          cityWise:
                            priceDetail["30_days_avg_price_sb"]?.toLocaleString(
                              "en-IN",
                              { maximumFractionDigits: 0 }
                            ) || "N/A",
                        };
                        dataSource.push(rowData);
                        // Highlight the lowest unit price among latest BID for each vendor (per diameter row)
                        if (!rowData.isSummary && rowData.diameter) {
                          // Get all vendor keys for this row
                          const vendorKeys = Object.keys(rowData)
                            .filter(
                              (key) =>
                                key.endsWith("UnitPrice") &&
                                !key.includes("R") // Only base UnitPrice, not R0/R1
                            )
                            .map((key) => key.replace("UnitPrice", ""));
                          // For each vendor, get their latest available price (R > R1 > R0)
                          const latestPrices = [];
                          vendorKeys.forEach((vendorKey) => {
                            const priceKeys = [
                              `${vendorKey}UnitPrice`, // R (Final)
                              `${vendorKey}UnitPriceR1`, // R1 (Revised)
                              `${vendorKey}UnitPriceR0`, // R0 (Initial)
                            ];
                            let latestVal = null;
                            let latestKey = null;
                            for (const key of priceKeys) {
                              let val = rowData[key];
                              if (
                                typeof val === "object" &&
                                val?.props?.children
                              ) {
                                val = val.props.children;
                              }
                              const numericVal = parseFloat((val || "0").toString().replace(/,/g, ""));
                              if (!isNaN(numericVal) && numericVal > 0) {
                                latestVal = numericVal;
                                latestKey = key;
                                break; // Use the first available (R > R1 > R0)
                              }
                            }
                            if (latestVal !== null && latestKey) {
                              latestPrices.push({ vendorKey, price: latestVal, key: latestKey });
                            }
                          });
                          // Find the minimum among the latest prices
                          let minPrice = null;
                          latestPrices.forEach((obj) => {
                            if (minPrice === null || obj.price < minPrice) {
                              minPrice = obj.price;
                            }
                          });
                          // Highlight all vendors with the minimum latest price
                          latestPrices.forEach((obj) => {
                            if (minPrice !== null && obj.price === minPrice && rowData[obj.key]) {
                              rowData[obj.key] = (
                                <span style={{ fontWeight: "bolder", color: "green" }}>
                                  {rowData[obj.key]?.props?.children || rowData[obj.key]}
                                </span>
                              );
                            }
                          });
                        }
                      });
                      if (
                        materialDetail.vendor_sub_total &&
                        materialDetail.vendor_sub_total.length > 0
                      ) {
                        const vendorSubTotals = materialDetail.vendor_sub_total;
                        const entries = [
                          {
                            srNo: "A1",
                            keySuffix: "basic_price",
                            city: "Basic Price",
                          },
                          {
                            srNo: "B1",
                            keySuffix: "commission_charges",
                            city: "Commission Charges",
                          },
                          { srNo: "C1", keySuffix: "taxes", city: "Taxes" },
                          {
                            srNo: "D1",
                            keySuffix: "total_price",
                            city: "Total Price",
                          },
                          {
                            srNo: "E1",
                            keySuffix: "contingency",
                            city: "Contingency",
                          },
                          {
                            srNo: "F1",
                            keySuffix: "total_with_tax",
                            city: "Total With Tax",
                          },
                          {
                            srNo: "H1",
                            keySuffix: "payment_terms",
                            city: "Payment Terms",
                          },
                          {
                            srNo: "I1",
                            keySuffix: "payment_security_details",
                            city: "Payment Security Details",
                          },
                          {
                            srNo: "K1",
                            keySuffix: "commercial_ranking",
                            city: "Commercial Ranking on Total Price",
                          },
                        ];

                        let uniqueKeyCounter = 0;
                        entries.forEach((entry) => {
                          const rowData = {
                            key: `${entry.keySuffix}-${uniqueKeyCounter++}`,
                            city: entry.city,
                            srNo: entry.srNo,
                            isSummary: true,
                          };
                          if (entry.keySuffix === "commercial_ranking") {
                            const roundDetails = vendorSubTotals
                              .map((vendorDetail) => {
                                const latestRound = findLatestAvailableRound(
                                  vendorDetail,
                                  vendorSubTotals
                                );
                                return vendorSubTotals.find(
                                  (v) =>
                                    v.vendor_name === vendorDetail.vendor_name &&
                                    v.round === latestRound
                                );
                              })
                              .filter(Boolean);
                            const commercialRankingValues = roundDetails
                              .map((vendor) => vendor.commercial_ranking)
                              .filter((value) => typeof value === "number");
                            const sortedRankingValues = [
                              ...new Set(commercialRankingValues),
                            ].sort((a, b) => a - b);
                            const lowest = sortedRankingValues[0] || null;
                            const secondLowest = sortedRankingValues[1] || null;
                            const thirdLowest = sortedRankingValues[2] || null;
                            ["r0", "r1", "r"].forEach((round) => {
                              const roundDetails = vendorSubTotals.filter(
                                (vendorDetail) => vendorDetail.round === round
                              );
                              roundDetails.forEach((vendorDetail) => {
                                const vendorKey = vendorDetail.vendor_name
                                  .toLowerCase()
                                  .replace(/\s+/g, "");
                                let cellContent = null;
                                // Only show for latest round, blank for others
                                const latestRound = findLatestAvailableRound(
                                  vendorDetail,
                                  vendorSubTotals
                                );
                                if (vendorDetail.round === latestRound) {
                                  if (
                                    vendorDetail.commercial_ranking === lowest
                                  ) {
                                    cellContent = (
                                      <Tooltip
                                        color={"#094E8F"}
                                        placement="top"
                                        title={
                                          <span style={{ color: "#fff" }}>
                                            Lowest Price
                                          </span>
                                        }
                                      >
                                        <span className="lowest">L1</span>
                                      </Tooltip>
                                    );
                                  } else if (
                                    vendorDetail.commercial_ranking === secondLowest
                                  ) {
                                    cellContent = (
                                      <Tooltip
                                        color={"#094E8F"}
                                        placement="top"
                                        title={
                                          <span style={{ color: "#fff" }}>
                                            Second Lowest Price
                                          </span>
                                        }
                                      >
                                        <span className="secondLowest">L2</span>
                                      </Tooltip>
                                    );
                                  } else if (
                                    vendorDetail.commercial_ranking === thirdLowest
                                  ) {
                                    cellContent = (
                                      <Tooltip
                                        color={"#094E8F"}
                                        placement="top"
                                        title={
                                          <span style={{ color: "#fff" }}>
                                            Third Lowest Price
                                          </span>
                                        }
                                      >
                                        <span className="thirdLowest">L3</span>
                                      </Tooltip>
                                    );
                                  } else {
                                    cellContent = null;
                                  }
                                } else {
                                  cellContent = null; // Blank for non-latest rounds
                                }
                                rowData[
                                  `${vendorKey}Amount${round.toUpperCase()}`
                                ] = cellContent;
                                rowData[`${vendorKey}Amount`] = cellContent;
                              });
                            });
                          } else {
                            vendorSubTotals.forEach((vendorDetail) => {
                              const vendorKey = vendorDetail.vendor_name
                                .toLowerCase()
                                .replace(/\s+/g, "");
                              const round = vendorDetail.round
                                ? vendorDetail.round.toUpperCase()
                                : "";
                              rowData[`${vendorKey}Amount${round}`] =
                                vendorDetail[entry.keySuffix] !== undefined
                                  ? vendorDetail[
                                      entry.keySuffix
                                    ].toLocaleString("en-IN", {
                                      maximumFractionDigits: 0,
                                    })
                                  : "N/A";
                              rowData[`${vendorKey}Amount`] =
                                vendorDetail[entry.keySuffix] !== undefined
                                  ? vendorDetail[entry.keySuffix].toLocaleString(
                                      "en-IN",
                                      { maximumFractionDigits: 0 }
                                    )
                                  : "N/A";
                            });
                          }
                          dataSource.push(rowData);
                        });
                        const materialRows = {};
                        vendorSubTotals.forEach((vendorDetail) => {
                          
                          const materialTypeDetails =
                            vendorDetail.material_type_details || {};
                          const vendorName = vendorDetail.vendor_name;
                          const vendorKey = vendorName
                            .toLowerCase()
                            .replace(/\s+/g, "");
                          const round = vendorDetail.round
                            ? vendorDetail.round.toUpperCase()
                            : "";
                          let currentSrNo = "L";
                          Object.entries(materialTypeDetails).forEach(
                            ([materialType, details]) => {
                              
                              if (details) {
                                const avgMT = details.average_unit_price_mt;
                                const avgBag = details.price_per_kg;
                                if (!materialRows[`${materialType}_MT`]) {
                                  materialRows[`${materialType}_MT`] = {
                                    srNo: `${currentSrNo}`,
                                    key: `${materialType}_MT_row`,
                                    city: `Average Price/MT - ${materialType}`,
                                    isSummary: true,
                                  };
                                }
                                if (!materialRows[`${materialType}_Bag`]) {
                                  materialRows[`${materialType}_Bag`] = {
                                    srNo: `${currentSrNo}1`,
                                    key: `${materialType}_Bag_row`,
                                    city: `Average Price/KG - ${materialType}`,
                                    isSummary: true,
                                  };
                                }
                                currentSrNo = String.fromCharCode(
                                  currentSrNo.charCodeAt(0) + 1
                                );
                                
                                materialRows[`${materialType}_MT`][
                                  `${vendorKey}Amount${round}`
                                ] = avgMT?.toFixed(2) || "N/A";
                                materialRows[`${materialType}_Bag`][
                                  `${vendorKey}Amount${round}`
                                ] = avgBag?.toFixed(2) || "N/A";
                                materialRows[`${materialType}_MT`][
                                  `${vendorKey}Amount`
                                ] = avgMT?.toFixed(2) || "N/A";
                                materialRows[`${materialType}_Bag`][
                                  `${vendorKey}Amount`
                                ] = avgBag?.toFixed(2) || "N/A";
                              }
                            }
                          );
                        });
                        
                        Object.values(materialRows).forEach((row) =>
                          dataSource.push(row)
                        );
                      }
                      if (
                        materialDetail.vendor_summary &&
                        materialDetail.vendor_summary.length > 0
                      ) {
                        const vendorSummaryTotals =
                          materialDetail.vendor_summary;
                        let uniqueSummaryKeyCounter = 1;
                        const summaryEntries = [
                          {
                            keySuffix: "supply_site_wise",
                            siteName: "Supply - Site Wise",
                          },
                          {
                            keySuffix: "freight_site_wise",
                            siteName: "Freight - Site Wise",
                          },
                          {
                            keySuffix: "sub_total",
                            siteName:
                              "Sub Total (Site Wise) (Supply + Freight)",
                          },
                          {
                            keySuffix: "supply_site_order_value",
                            siteName:
                              "Supply as a % of respective site order value",
                          },
                          {
                            keySuffix: "freight_site_order_value",
                            siteName:
                              "Freight as a % of respective site order value",
                          },
                        ];
                        summaryEntries.forEach((entry) => {
                          const rowData = {
                            srNo: `${uniqueSummaryKeyCounter++}`,
                            title: entry.siteName,
                            uom: entry.keySuffix,
                          };
                          vendorSummaryTotals.forEach((vendorDetail) => {
                            const vendorKey = vendorDetail.vendor_name
                              .toLowerCase()
                              .replace(/\s+/g, "");
                            rowData[`${vendorKey}Amount`] =
                              entry.keySuffix === "supply_site_order_value" ||
                              entry.keySuffix === "freight_site_order_value"
                                ? `${vendorDetail[entry.keySuffix]?.toFixed(2)}`
                                : `${vendorDetail[
                                    entry.keySuffix
                                  ]?.toLocaleString("en-IN", {
                                    maximumFractionDigits: 0,
                                  })}`;
                          });
                          dataSource.push(rowData);
                        });
                      }
                    }
                  );
                }
              );
            }
          );
          let summaryDataSource = [];
          response1.data.data.comparative_details_by_rfq_site_wise.forEach(
            (cityDetail) => {
              cityDetail.rfq_site_wise_details.forEach((siteDetail) => {
                siteDetail.rfq_material_wise_details.forEach(
                  (materialDetail) => {
                    if (
                      materialDetail.vendor_summary &&
                      materialDetail.vendor_summary.length !== 0
                    ) {
                      const vendorSummaryTotals = materialDetail.vendor_summary;
                      if (vendorSummaryTotals.length > 0) {
                        let uniqueSummaryKeyCounter = 1;
                        const summaryEntries = [
                          {
                            keySuffix: "supply_site_wise",
                            siteName: "Supply - Site Wise",
                          },
                          {
                            keySuffix: "freight_site_wise",
                            siteName: "Freight - Site Wise",
                          },
                          {
                            keySuffix: "sub_total",
                            siteName: "Sub Total (Site Wise)",
                          },
                          {
                            keySuffix: "supply_site_order_value",
                            siteName:
                              "Supply as a % of respective site order value",
                          },
                          {
                            keySuffix: "freight_site_order_value",
                            siteName:
                              "Freight as a % of respective site order value",
                          },
                        ];
                        summaryEntries.forEach((entry) => {
                          const rowData = {
                            srNo: `${uniqueSummaryKeyCounter++}`,
                            title: entry.siteName,
                            uom: entry.keySuffix,
                          };
                          vendorSummaryTotals.forEach((vendorDetail) => {
                            const vendorKey = vendorDetail.vendor_name
                              .toLowerCase()
                              .replace(/\s+/g, "");
                            rowData[`${vendorKey}Amount`] =
                              entry.keySuffix === "supply_site_order_value" ||
                              entry.keySuffix === "freight_site_order_value"
                                ? `${vendorDetail[entry.keySuffix]?.toFixed(2)}`
                                : `${vendorDetail[
                                    entry.keySuffix
                                  ]?.toLocaleString("en-IN", {
                                    maximumFractionDigits: 0,
                                  })}`;
                          });
                          summaryDataSource.push(rowData);
                        });
                      }
                    }
                  }
                );
              });
            }
          );
          const summaryTitlesToRemove = [
            "Supply - Site Wise",
            "Freight - Site Wise",
            "Sub Total (Site Wise)",
            "Sub Total (Site Wise) (Supply + Freight)",
            "Supply as a % of respective site order value",
            "Freight as a % of respective site order value",
            "sub_total",
          ];
          dataSource = dataSource.filter(
            (row) =>
              !summaryTitlesToRemove.includes(row.city) &&
              !summaryTitlesToRemove.includes(row.title)
          );
          setDataSource(dataSource);
          setSummaryDataSource(summaryDataSource);
          const vendorArr = Array.from(uniqueVendors);
          setVendors(vendorArr);
          setVendorBidDates(vendorBidDatesTemp);
          const vendorSummaryColumns = (
            Array.isArray(vendorArr) ? vendorArr : []
          ).map((vendorName) => {
            let round = "";

            const vendorKey = vendorName.toLowerCase().replace(/\s+/g, "");
            const bidDates = vendorBidDatesTemp[vendorKey] || {};

            const hasFinalBid =
              bidDates.finalBidDate && bidDates.finalBidDate !== "N/A";
            const hasRevisedBid =
              bidDates.revisedBidDate && bidDates.revisedBidDate !== "N/A";
            const hasInitialBid =
              bidDates.initialBidDate && bidDates.initialBidDate !== "N/A";

            if (hasFinalBid) {
              round = "R - Final";
            } else if (hasRevisedBid) {
              round = "R1 - Revised";
            } else if (hasInitialBid) {
              round = "R0 - Initial";
            }

            return {
              title: vendorName,
              children: [
                {
                  title: round || "N/A",
                  align: "center",
                  children: [
                    {
                      title: "Basic Amount",
                      dataIndex: `${vendorKey}Amount`,
                      key: `${vendorKey}Amount`,
                      align: "right",
                      render: (value) => value || "N/A",
                    },
                  ],
                },
              ],
            };
          });
          setSummaryColumn(vendorSummaryColumns);

          // --- BEGIN: Add city and material filter options (from ComparativeSiteWise.js) ---
          // Set city filter options
          const cities =
            response1.data.data.comparative_details_by_rfq_site_wise.flatMap(
              (cityItem, cityIndex) => ({
                name: cityItem.rfq_city_name,
                id: cityIndex,
              })
            );
          setSiteName(cities);

          // Set material filter options
          const materialTypes =
            response1.data.data.comparative_details_by_rfq_site_wise.flatMap(
              (cityItem) =>
                cityItem.rfq_site_wise_details.flatMap((siteItem) =>
                  siteItem.rfq_material_wise_details.map((materialItem) => ({
                    id: materialItem.rfq_material_type_id,
                    name: materialItem.rfq_material_type_name,
                  }))
                )
            );
          const uniqueMaterialTypes = materialTypes.filter(
            (material, index, self) =>
              index ===
              self.findIndex(
                (m) => m.id === material.id && m.name === material.name
              )
          );
          setMaterialName(uniqueMaterialTypes);
          // --- END: Add city and material filter options ---
        } else {
          ErrorNotificationMsg(t("Error fetching site details"));
        }
        setapiLoading(false);
      } catch (error) {
        console.error("Failed to fetch data:", error);
        setapiLoading(false);
      }
    };
    getVendorBidRFQ();
  }, [id]);








  
  const venColumn = Array.isArray(vendors)
    ? vendors.flatMap((vendorName) => {
        const vendorKey = vendorName.toLowerCase().replace(/\s+/g, "");
        const bidDates = vendorBidDates[vendorKey] || {};

        let latest = null;
        if (bidDates.finalBidDate && bidDates.finalBidDate !== "N/A") {
          latest = "R";
        } else if (
          bidDates.revisedBidDate &&
          bidDates.revisedBidDate !== "N/A"
        ) {
          latest = "R1";
        } else if (
          bidDates.initialBidDate &&
          bidDates.initialBidDate !== "N/A"
        ) {
          latest = "R0";
        }

        const columns = [];

        if (latest === "R") {
          columns.push({
            title: (
              <>
                <p>R - Final</p>
                <p>{bidDates.finalBidDate}</p>
              </>
            ),
            className: "vencolumn",
            children: [
              {
                title: "Unit Price",
                dataIndex: `${vendorKey}UnitPrice`,
                key: `${vendorKey}UnitPrice`,
                className: "vencolumn",
                width: 80,
                align: "right",
                render: (value, record) => {
                  if (record.isSummary) {
                    return "";
                  }
                  return value || "";
                },
              },
              {
                title: "Basic Amount",
                dataIndex: `${vendorKey}Amount`,
                key: `${vendorKey}Amount`,
                width: 80,
                align: "right",
                className: "vencolumn",
                 render: (value, record) => { 
                if (record.city === 'Commercial Ranking on Total Price') {
                return (
                  <span>{value && value !== 'N/A' && value || ""}</span>
                )
                } else {
                return (
                  <span>{value || ""}</span>
                )
                }
                },
              },
            ],
          });
        } else if (latest === "R1") {
          columns.push({
            title: (
              <>
                <p>R1 - Revised</p>
                <p>{bidDates.revisedBidDate}</p>
              </>
            ),
            className: "vencolumn",
            children: [
              {
                title: "Unit Price",
                dataIndex: `${vendorKey}UnitPriceR1`,
                key: `${vendorKey}UnitPriceR1`,
                className: "vencolumn",
                align: "right",
                width: 80,
                render: (value, record) => {
                  if (record.isSummary) {
                    return "";
                  }
                  return value || "";
                },
              },
              {
                title: "Basic Amount",
                dataIndex: `${vendorKey}AmountR1`,
                key: `${vendorKey}AmountR1`,
                align: "right",
                className: "vencolumn",
                width: 80,
                render: (value, record) => { 
                if (record.city === 'Commercial Ranking on Total Price') {
                return (
                  <span>{value && value !== 'N/A' && value || ""}</span>
                )
                } else {
                return (
                  <span>{value || ""}</span>
                )
                }
                },
              },
            ],
          });
        } else if (latest === "R0") {
          columns.push({
            title: (
              <>
                <p>R0 - Initial</p>
                <p>{bidDates.initialBidDate}</p>
              </>
            ),
            className: "vencolumn",
            children: [
              {
                title: "Unit Price",
                dataIndex: `${vendorKey}UnitPriceR0`,
                key: `${vendorKey}UnitPriceR0`,
                className: "vencolumn",
                align: "right",
                width: 80,
                render: (value, record) => {
                  if (record.isSummary) {
                    return "";
                  }
                  return value || "";
                },
              },
              {
                title: "Basic Amount",
                dataIndex: `${vendorKey}AmountR0`,
                key: `${vendorKey}AmountR0`,
                align: "right",
                className: "vencolumn",
                width: 80,
                 render: (value, record) => { 
                if (record.city === 'Commercial Ranking on Total Price') {
                return (
                  <span>{value && value !== 'N/A' && value || ""}</span>
                )
                } else {
                return (
                  <span>{value || ""}</span>
                )
                }
                },
              },
            ],
          });
        }

        if (
          showR1 &&
          bidDates.revisedBidDate &&
          bidDates.revisedBidDate !== "N/A" &&
          latest !== "R1"
        ) {
          columns.push({
            title: (
              <>
                <p>R1 - Revised</p>
                <p>{bidDates.revisedBidDate}</p>
              </>
            ),
            className: "vencolumn",
            children: [
              {
                title: "Unit Price",
                dataIndex: `${vendorKey}UnitPriceR1`,
                key: `${vendorKey}UnitPriceR1`,
                className: "vencolumn",
                align: "right",
                width: 80,
                render: (value, record) => {
                  if (record.isSummary) {
                    return "";
                  }
                  return value || "N/A";
                },
              },
              {
                title: "Basic Amount",
                dataIndex: `${vendorKey}AmountR1`,
                key: `${vendorKey}AmountR1`,
                align: "right",
                className: "vencolumn",
                width: 80,
                 render: (value, record) => { 
                if (record.city === 'Commercial Ranking on Total Price') {
                return (
                  <span>{value && value !== 'N/A' && value || ""}</span>
                )
                } else {
                return (
                  <span>{value || ""}</span>
                )
                }
                },
              },
            ],
          });
        }

        if (
          showR0 &&
          bidDates.initialBidDate &&
          bidDates.initialBidDate !== "N/A" &&
          latest !== "R0"
        ) {
          columns.push({
            title: (
              <>
                <p>R0 - Initial</p>
                <p>{bidDates.initialBidDate}</p>
              </>
            ),
            className: "vencolumn",
            children: [
              {
                title: "Unit Price",
                dataIndex: `${vendorKey}UnitPriceR0`,
                key: `${vendorKey}UnitPriceR0`,
                className: "vencolumn",
                align: "right",
                width: 80,
                render: (value, record) => {
                  if (record.isSummary) {
                    return "";
                  }
                  return value || "N/A";
                },
              },
              {
                title: "Basic Amount",
                dataIndex: `${vendorKey}AmountR0`,
                key: `${vendorKey}AmountR0`,
                align: "right",
                className: "vencolumn",
                width: 80,
                 render: (value, record) => { 
                if (record.city === 'Commercial Ranking on Total Price') {
                return (
                  <span>{value && value !== 'N/A' && value || ""}</span>
                )
                } else {
                return (
                  <span>{value || ""}</span>
                )
                }
                },
              },
            ],
          });
        }

        if (columns.length === 0) return [];
        return [
          {
            title: <span style={{ color: "#094E8F" }}>{vendorName}</span>,
            className: "vencolumn",
            children: columns,
          },
        ];
      })
    : [];

  const allVendors = Array.isArray(vendors) ? vendors.flat(3) : [];
  const allMaterials = Array.isArray(vendors) ? vendors.flat(2) : [];

  const getCustomText = (text, record) => {
    if (record.city === "Basic Price") {
      return `${text}`;
    } else if (record.city === "Taxes") {
      return (
        <Tooltip
          color={"#094E8F"}
          placement="top"
          title={
            <span style={{ color: "#fff" }}>Sum of basic amount * GST</span>
          }
        >
          {`${text}`}
        </Tooltip>
      );
    } else if (record.city === "Commission Charges") {
      return (
        <Tooltip
          color={"#094E8F"}
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Sum of basic amount * commission charge from business setting
            </span>
          }
        >
          {`${text}`}
        </Tooltip>
      );
    } else if (record.city === "Contingency") {
      return (
        <Tooltip
          color={"#094E8F"}
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Sum of basic amount * Contingency charge from business setting
            </span>
          }
        >
          {text} @ {contengency}% on [
          <Tooltip
            color={"#094E8F"}
            placement="right"
            title={<span style={{ color: "#fff" }}>Total Evaluated Price</span>}
          >
            <span style={{ backgroundColor: "#FFD3B3", padding: "5px" }}>
              D1
            </span>
          </Tooltip>
          ]
        </Tooltip>
      );
    } else if (record.city === "Total Without Tax") {
      return (
        <>
          {text} [
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Basic Price</span>}
          >
            <span style={{ backgroundColor: "#A3F2EB", padding: "5px" }}>
              A1
            </span>
          </Tooltip>
          ]
        </>
      );
    } else if (record.city === "Commercial Ranking on Total Price") {
      return (
        <>
          {text} [
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Total Evaluated Price</span>}
          >
            <span style={{ backgroundColor: "#FFD3B3", padding: "5px" }}>
              D1
            </span>
          </Tooltip>
          ]
        </>
      );
    } else if (record.city === "Total Price") {
      return (
        <>
          {"Total Evaluated Price"} [
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Basic Price</span>}
          >
            <span style={{ backgroundColor: "#A3F2EB", padding: "5px" }}>
              A1
            </span>
          </Tooltip>{" "}
          +{" "}
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Commission Charges</span>}
          >
            <span style={{ backgroundColor: "#CCD5FF", padding: "5px" }}>
              B1
            </span>
          </Tooltip>{" "}
          +{" "}
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Taxes</span>}
          >
            <span style={{ backgroundColor: "#FFEFA8", padding: "5px" }}>
              C1
            </span>
          </Tooltip>
          ]
        </>
      );
    } else if (record.city === "Total With Tax") {
      return (
        <>
          {"Total Proposed Cost"} [
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Total Evaluated Price</span>}
          >
            <span style={{ backgroundColor: "#FFD3B3", padding: "5px" }}>
              D1
            </span>
          </Tooltip>{" "}
          +{" "}
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Contingency</span>}
          >
            <span style={{ backgroundColor: "#FF9E96", padding: "5px" }}>
              E1
            </span>
          </Tooltip>
          ]
        </>
      );
    }
    return text;
  };

  const predefinedColors = {
    A1: "#A3F2EB",
    B1: "#CCD5FF",
    C1: "#FFEFA8",
    D1: "#FFD3B3",
    E1: "#FF9E96",
    F1: "#F4B9F4",
    G1: "#CCE5E5",
    H1: "#E1FF97",
    I1: "#ADFFC7",
    K1: "rgb(255 231 231)",
    L: "rgb(255 157 43)",
    L1: "rgb(225 127 43)",
    M: "rgb(155 157 3)",
    M1: "rgb(255 245 84)",
  };

  const getColor = (text) => {
    if (/^\d/.test(text)) {
      return null;
    }

    if (predefinedColors[text]) {
      return predefinedColors[text];
    }

    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = hash % 360;
    return `hsl(${hue}, 70%, 80%)`;
  };


  const dynamicSummaryColorMap = {};
  const dynamicSummaryColorList = [
    '#FFB300', '#803E75', '#FF6800', '#A6BDD7', '#C10020', '#CEA262', '#817066',
    '#007D34', '#F6768E', '#00538A', '#FF7A5C', '#bd568a', '#FF8E00', '#B32851',
    '#F4C800', '#7F180D', '#93AA00', '#593315', '#F13A13', '#232C16',
  ];
  let dynamicSummaryColorIndex = 0;
  function getDistinctDynamicColor(key) {
    if (!dynamicSummaryColorMap[key]) {
      if (dynamicSummaryColorIndex < dynamicSummaryColorList.length) {
        dynamicSummaryColorMap[key] = dynamicSummaryColorList[dynamicSummaryColorIndex++];
      } else {
        const hue = (dynamicSummaryColorIndex * 47) % 360;
        dynamicSummaryColorMap[key] = `hsl(${hue}, 70%, 80%)`;
        dynamicSummaryColorIndex++;
      }
    }
    return dynamicSummaryColorMap[key];
  }

  const hiddencolumns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      key: "srNo",
      width: 40,
      align: "center",
      render: (text, record) => {
        if (record.isSummary) {
          let color, label;
          if (summaryRowMeta[record.srNo]) {
            color = summaryRowMeta[record.srNo].color;
            label = summaryRowMeta[record.srNo].label;
          } else {
            color = getDistinctDynamicColor(record.srNo);
            label = record.srNo;
          }
          return (
            <span
              style={{
                backgroundColor: color,
                color: "#333",
                borderRadius: 4,
                padding: "2px 8px",
                fontWeight: "bold",
                minWidth: 32,
                display: "inline-block",
                textAlign: "center",
              }}
            >
              {label}
            </span>
          );
        }
        // For normal rows, show the running number or text
        return text;
      },
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: 30,
      render: (text, record, index) => {
        const a1Index = dataSource1.findIndex(
          (row) => row && row.srNo === "A1"
        );
        const nextRow = dataSource1[index + 1];
        if (a1Index !== -1 && index >= a1Index) {
          return {
            children: getCustomText(text, record), // Apply tooltip-based rendering
            props: {
              colSpan: 2,
            },
          };
        } else {
          return {
            children: getCustomText(text, record),
            props: {
              colSpan: 1,
            },
          };
        }
      },
    },

    {
      title: "Site",
      dataIndex: "site",
      key: "site",
      width: 20,
    },
    {
      title: "Material Type",
      dataIndex: "materialType",
      key: "materialType",
      width: 120,
    },
    // Insert Diameter column here
    {
      title: "Diameter",
      dataIndex: "diameter",
      key: "diameter",
      align: "center",
      width: 80,
    },
    showGST && {
      title: (
        <>
          <p>GST</p>
          <p>(%)</p>
        </>
      ),
      dataIndex: "gst_rate",
      key: "gst_rate",
      width: 40,
      align: "center",
    },
    {
      title: "Qty.",
      dataIndex: "qty",
      key: "qty",
      align: "center",
      width: "auto",
      render: (text, record, index) =>
        text?.toLocaleString("en-IN", { maximumFractionDigits: 0 }),
    },
    {
      title: "UoM.",
      dataIndex: "uom",
      key: "uom",
      align: "center",
      width: "auto",
      render: (text, record) => (text === "Cubic Meter" ? "Cu. Mtr." : text),
    },
    showLPP && {
      title: "LPP (Last Purchase Price)",
      children: [
        {
          title: "Last order detail",
          children: [
            {
              title: "PO & Date",
              dataIndex: "poDate",
              key: "poDate",
              width: 90,
              render: (text, record) => {
                if (!text) return "";
                const [poNumber, date] = text.split(" - ");
                return (
                  <>
                    <p style={{ fontSize: "12px" }}>{poNumber}</p>
                    <p style={{ fontSize: "12px" }}>{date}</p>
                  </>
                );
              },
            },
            {
              title: "Vendor Name",
              dataIndex: "vendorName",
              key: "vendorName",
              width: 90,
            },
            {
              title: "Unit Price",
              dataIndex: "unitPrice",
              key: "unitPrice",
              width: 80,
              align: "right",
              render: (value, record) => {
                if (record.isSummary) {
                  return "";
                }
                return value;
              },
            },
          ],
        },
        {
          title: (
            <Tooltip
              color="#094E8F"
              placement="top"
              title="Last 30 Days Avg. Price"
            >
              30DAP{" "}
              <InfoCircleOutlined
                style={{ color: "#094E8F", marginLeft: "3px" }}
              />
            </Tooltip>
          ),
          width: 100,
          align: "right",
          children: [
            {
              title: "",
              dataIndex: "avgPrice",
              key: "avgPrice",
              width: 100,
              align: "right",
            },
          ],
        },
      ],
    },
    {
      title: (
        <Tooltip color="#094E8F" placement="top" title="Item wise L1">
          IWL1{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      children: [
        {
          title: "",
          dataIndex: "itemWiseL1",
          key: "itemWiseL1",
          width: 100,
          align: "right",
          render: (text, record) => <strong>{text}</strong>,
        },
      ],
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title="Last 30 Days CityWise Avg. Price on Smart Buyer"
        >
          30DAP {""}{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      width: 80,
      children: [
        {
          title: "",
          dataIndex: "cityWise",
          width: 120,
          key: "cityWise",
          align: "right",
        },
      ],
    },
    ...venColumn,
  ].filter(Boolean);

  const hiddencolumns1 = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      key: "srNo",
      width: 40,
      align: "center",
      render: (text, record) => {
        if (record.isSummary) {
          let color, label;
          if (summaryRowMeta[record.srNo]) {
            color = summaryRowMeta[record.srNo].color;
            label = summaryRowMeta[record.srNo].label;
          } else {
            color = getDistinctDynamicColor(record.srNo);
            label = record.srNo;
          }
          return (
            <span
              style={{
                backgroundColor: color,
                color: "#333",
                borderRadius: 4,
                padding: "2px 8px",
                fontWeight: "bold",
                minWidth: 32,
                display: "inline-block",
                textAlign: "center",
              }}
            >
              {label}
            </span>
          );
        }
        // For normal rows, show the running number or text
        return text;
      },
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: 30,
      render: (text, record, index) => {
        const a1Index = dataSource1.findIndex(
          (row) => row && row.srNo === "A1"
        );
        const nextRow = dataSource1[index + 1];
        if (a1Index !== -1 && index >= a1Index) {
          return {
            children: getCustomText(text, record),
            props: { colSpan: 2 },
          };
        } else {
          return {
            children: getCustomText(text, record),
            props: { colSpan: 1 },
          };
        }
      },
    },
    {
      title: "Site",
      dataIndex: "site",
      key: "site",
      width: 20,
    },
    {
      title: "Grade & Quality",
      dataIndex: "materialType",
      key: "materialType",
      width: 120,
      render: (text, record, index) => {
        const nextRow = dataSource1[index + 1];

        const a1Index = dataSource1.findIndex((row) => row.srNo === "A1");

        if (index >= a1Index) {
          return {
            children: text,
            props: {
              colSpan: 0,
            },
          };
        } else {
          return text;
        }
      },
    },
    showGST && {
      title: (
        <>
          <p>GST</p>
          <p>(%)</p>
        </>
      ),
      dataIndex: "gst_rate",
      key: "gst_rate",
      width: 40,
      align: "center",
    },
    {
      title: "UoM.",
      dataIndex: "uom",
      key: "uom",
      align: "center",
      width: "auto",
      render: (text, record) => (text === "Cubic Meter" ? "Cu. Mtr." : text),
    },
    {
      title: "Diameter",
      dataIndex: "diameter",
      key: "diameter",
      align: "center",
      width: 80,
    },

    {
      title: "Qty.",
      dataIndex: "qty",
      key: "qty",
      align: "center",
      width: "auto",
      render: (text, record, index) =>
        text?.toLocaleString("en-IN", { maximumFractionDigits: 0 }),
    },

    showLPP && {
      title: "LPP (Last Purchase Price)",
      children: [
        {
          title: "Last order detail",
          children: [
            {
              title: "PO & Date",
              dataIndex: "poDate",
              key: "poDate",
              width: 90,
              render: (text, record) => {
                if (!text) return "";
                const [poNumber, date] = text.split(" - ");
                return (
                  <>
                    <p style={{ fontSize: "12px" }}>{poNumber}</p>
                    <p style={{ fontSize: "12px" }}>{date}</p>
                  </>
                );
              },
            },
            {
              title: "Vendor Name",
              dataIndex: "vendorName",
              key: "vendorName",
              width: 90,
            },
            {
              title: "Unit Price",
              dataIndex: "unitPrice",
              key: "unitPrice",
              width: 80,
              align: "right",
              render: (value, record) => {
                if (record.isSummary) {
                  return "";
                }
                return value;
              },
            },
          ],
        },
        {
          title: (
            <Tooltip
              color="#094E8F"
              placement="top"
              title="Last 30 Days Avg. Price"
            >
              30DAP{" "}
              <InfoCircleOutlined
                style={{ color: "#094E8F", marginLeft: "3px" }}
              />
            </Tooltip>
          ),
          width: 100,
          align: "right",
          children: [
            {
              title: "",
              dataIndex: "avgPrice",
              key: "avgPrice",
              width: 100,
              align: "right",
            },
          ],
        },
      ],
    },
    {
      title: (
        <Tooltip color="#094E8F" placement="top" title="Item wise L1">
          IWL1{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      children: [
        {
          title: "",
          dataIndex: "itemWiseL1",
          key: "itemWiseL1",
          width: 100,
          align: "right",
          render: (text, record) => <strong>{text}</strong>,
        },
      ],
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title="Last 30 Days CityWise Avg. Price on Smart Buyer"
        >
          30DAP {""}{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      width: 80,
      children: [
        {
          title: "",
          dataIndex: "cityWise",
          width: 120,
          key: "cityWise",
          align: "right",
        },
      ],
    },
    ...venColumn,
  ].filter(Boolean);

  const handleCheckboxhideR1 = () => {
    setShowR0(!showR0);
  };

  const handleCheckboxhideR = () => {
    setShowR1(!showR1);
  };

  const handleCheckboxhideLPP = () => {
    setShowLPP(!showLPP);
  };

  const handleCheckboxhideGST = () => {
    setShowGST(!showGST);
  };

  const handleCheckboxhideRR = () => {
    setHideRBidPrice(!hideRBidPrice);
  };

  const updateState = async () => {
      setapiLoading(true);

    try {
      const noFiltersActive = !state.material_type_names?.length;

      const payload = {
        city_names: state.city_names.length !== 0 ? state.city_names : null,
        site_names: state.site_names.length !== 0 ? state.site_names : null,
        material_type_names:
          state.material_type_names.length !== 0
            ? state.material_type_names
            : null,
      };
      const response1 = await patchRequest(
        `comparative-rfq/${id}/get-comparative-details-by-city-wise/`,
        payload
      );

      if (response1.data.data) {
        let dataSource = [];
        let prevCity = "";
        let prevSite = "";
        const uniqueVendors = new Set();
        let vendorBidDatesTemp = {};
        response1.data.data.comparative_details_by_rfq_site_wise.forEach(
          (cityDetail, cityIndex) => {
            let prevSubCategory = "";
            cityDetail.rfq_site_wise_details.forEach(
              (siteDetail, siteIndex) => {
                siteDetail.rfq_material_wise_details.forEach(
                  (materialDetail, materialIndex) => {
                    
                    const diameterSet = new Set();
                    (materialDetail.vendors || []).forEach((vendor) => {

                      (vendor.diameter_details || []).forEach((dia) => {
                        if (
                          dia.diameter_value !== undefined &&
                          dia.diameter_value !== null
                        ) {
                          diameterSet.add(Number(dia.diameter_value));
                        }
                      });
                      uniqueVendors.add(vendor.vendor_name);
                    });
                    const uniqueDiameters = Array.from(diameterSet).sort(
                      (a, b) => a - b
                    );
                    
                    uniqueDiameters.forEach((diameter, diaIndex) => {
                      
                      const isFirstMaterial = diaIndex === 0;
                      const showCity =
                        isFirstMaterial && prevCity !== cityDetail.rfq_city_name
                          ? cityDetail.rfq_city_name
                          : "";
                      const showSite =
                        prevSite !== siteDetail.rfq_site_name
                          ? siteDetail.rfq_site_name
                          : "";
                      if (isFirstMaterial) prevCity = cityDetail.rfq_city_name;
                      prevSite = siteDetail.rfq_site_name;
                      const currentSubCategory = materialDetail.rfq_material_type_sub_category || "";
                    const showSubCategory =
                      diaIndex === 0 &&
                      (materialIndex === 0 || currentSubCategory !== prevSubCategory)
                        ? currentSubCategory
                        : "";
                      let rowData = {
                        key: `row-${cityIndex}-${siteIndex}-${materialIndex}-${diaIndex}`,
                        srNo: `${cityIndex + 1}.${siteIndex + 1}`,
                        city: showCity,
                        site: showSite,
                        subCategory: showSubCategory,
                        materialType: isFirstMaterial
                          ? materialDetail.rfq_material_type_name
                          : "",
                        diameter: diameter ? `${diameter} MM` : "",
                        qty: "",
                        uom: isFirstMaterial
                          ? materialDetail.rfq_material_type_uom || ""
                          : "",
                        gst_rate: isFirstMaterial
                          ? materialDetail.gst_rate
                          : "",
                      };

                      // Group vendors by name and merge diameter_details
                      const vendorMap = {};
                      (materialDetail?.vendors || []).forEach((vendor) => {
                        
                        const key = vendor.vendor_name.toLowerCase().replace(/\s+/g, "");
                        if (!vendorMap[key]) {
                          vendorMap[key] = { ...vendor, diameter_details: [...(vendor?.diameter_details || [])] };
                        } else {
                          vendorMap[key].diameter_details = [
                            ...(vendorMap[key]?.diameter_details || []),
                            ...(vendor?.diameter_details || [])
                          ];
                        }
                      });
                      const mergedVendors = Object.values(vendorMap);
                      
                      mergedVendors.forEach((vendor) => {
                        const vendorKey = vendor.vendor_name
                          .toLowerCase()
                          .replace(/\s+/g, "");
                        const diaDetail = (vendor.diameter_details || []).find(
                          (d) => Number(d.diameter_value) === Number(diameter)
                        );
                        
                        const priceObj = diaDetail && 
                          diaDetail.r_price?.[0] ||
                          diaDetail.r1_price?.[0] ||
                          diaDetail.r0_price?.[0] ||
                          {};
                          
                        const priceR0 = diaDetail.r0_price?.[0] || {};
                        const priceR1 = diaDetail.r1_price?.[0] || {};
                        rowData[`${vendorKey}UnitPrice`] =
                          priceObj.r_unit_price !== undefined
                            ? priceObj.r_unit_price.toLocaleString("en-IN", {
                                maximumFractionDigits: 0,
                              })
                            : "N/A";
                        rowData[`${vendorKey}Amount`] =
                          priceObj.r_amount_without_gst !== undefined
                            ? priceObj.r_amount_without_gst.toLocaleString(
                                "en-IN",
                                { maximumFractionDigits: 0 }
                              )
                            : "N/A";
                        rowData[`${vendorKey}BidDate`] =
                          priceObj.bid_date || "N/A";
                        rowData[`${vendorKey}UnitPriceR0`] =
                          priceR0.r_unit_price !== undefined
                            ? priceR0.r_unit_price.toLocaleString("en-IN", {
                                maximumFractionDigits: 0,
                              })
                            : "N/A";
                        rowData[`${vendorKey}AmountR0`] =
                          priceR0.r_amount_without_gst !== undefined
                            ? priceR0.r_amount_without_gst.toLocaleString(
                                "en-IN",
                                { maximumFractionDigits: 0 }
                              )
                            : "N/A";
                        rowData[`${vendorKey}UnitPriceR1`] =
                          priceR1.r_unit_price !== undefined
                            ? priceR1.r_unit_price.toLocaleString("en-IN", {
                                maximumFractionDigits: 0,
                              })
                            : "N/A";
                        rowData[`${vendorKey}AmountR1`] =
                          priceR1.r_amount_without_gst !== undefined
                            ? priceR1.r_amount_without_gst.toLocaleString(
                                "en-IN",
                                { maximumFractionDigits: 0 }
                              )
                            : "N/A";
                        vendorBidDatesTemp[vendorKey] =
                          vendorBidDatesTemp[vendorKey] || {};
                        if (priceObj.bid_date)
                          vendorBidDatesTemp[vendorKey].finalBidDate =
                            priceObj.bid_date || "N/A";
                        if (priceR1.bid_date)
                          vendorBidDatesTemp[vendorKey].revisedBidDate =
                            priceR1.bid_date || "N/A";
                        if (priceR0.bid_date)
                          vendorBidDatesTemp[vendorKey].initialBidDate =
                            priceR0.bid_date || "N/A";
                      });
                      // Set quantity by finding any vendor with the current diameter
                      let foundQty = null;
                      for (const vendor of materialDetail.vendors || []) {
                        const diaDetail = (vendor.diameter_details || []).find(
                          (d) => Number(d.diameter_value) === Number(diameter)
                        );
                        if (diaDetail && diaDetail.diameter_quantity !== undefined && diaDetail.diameter_quantity !== null) {
                          foundQty = diaDetail.diameter_quantity;
                          break;
                        }
                      }
                      rowData.qty = foundQty !== null ? foundQty : "N/A";

                      const priceDetail =
                        (materialDetail.last_purchase_price || [])[0] || {};
                      // --- FIX itemWiseL1 logic ---
                      let itemWiseL1 = "N/A";
                      if (Array.isArray(priceDetail.item_wise_l1)) {
                        const l1Entry = priceDetail.item_wise_l1.find(
                          (l1) => Number(l1.diameter_value) === Number(diameter)
                        );
                        if (l1Entry && l1Entry.lowest_price !== undefined && l1Entry.lowest_price !== null) {
                          itemWiseL1 = l1Entry.lowest_price.toLocaleString("en-IN", { maximumFractionDigits: 0 });
                        }
                      }
                      rowData = {
                        ...rowData,
                        poDate: priceDetail.lpp_po_number_date || "N/A",
                        vendorName: priceDetail.vendor_name || "N/A",
                        unitPrice:
                          priceDetail.unit_price?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          }) || "N/A",
                        avgPrice:
                          priceDetail["30_days_avg_price"]?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          ) || "N/A",
                        itemWiseL1, // <-- use the fixed value
                        cityWise:
                          priceDetail["30_days_avg_price_sb"]?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          ) || "N/A",
                      };
                      dataSource.push(rowData);
                      // Highlight the lowest unit price among latest BID for each vendor (per diameter row)
                      if (!rowData.isSummary && rowData.diameter) {
                        // Get all vendor keys for this row
                        const vendorKeys = Object.keys(rowData)
                          .filter(
                            (key) =>
                              key.endsWith("UnitPrice") &&
                              !key.includes("R") // Only base UnitPrice, not R0/R1
                          )
                          .map((key) => key.replace("UnitPrice", ""));
                        // For each vendor, get their latest available price (R > R1 > R0)
                        const latestPrices = [];
                        vendorKeys.forEach((vendorKey) => {
                          const priceKeys = [
                            `${vendorKey}UnitPrice`, // R (Final)
                            `${vendorKey}UnitPriceR1`, // R1 (Revised)
                            `${vendorKey}UnitPriceR0`, // R0 (Initial)
                          ];
                          let latestVal = null;
                          let latestKey = null;
                          for (const key of priceKeys) {
                            let val = rowData[key];
                            if (
                              typeof val === "object" &&
                              val?.props?.children
                            ) {
                              val = val.props.children;
                            }
                            const numericVal = parseFloat((val || "0").toString().replace(/,/g, ""));
                            if (!isNaN(numericVal) && numericVal > 0) {
                              latestVal = numericVal;
                              latestKey = key;
                              break; // Use the first available (R > R1 > R0)
                            }
                          }
                          if (latestVal !== null && latestKey) {
                            latestPrices.push({ vendorKey, price: latestVal, key: latestKey });
                          }
                        });
                        // Find the minimum among the latest prices
                        let minPrice = null;
                        latestPrices.forEach((obj) => {
                          if (minPrice === null || obj.price < minPrice) {
                            minPrice = obj.price;
                          }
                        });
                        // Highlight all vendors with the minimum latest price
                        latestPrices.forEach((obj) => {
                          if (minPrice !== null && obj.price === minPrice && rowData[obj.key]) {
                            rowData[obj.key] = (
                              <span style={{ fontWeight: "bolder", color: "green" }}>
                                {rowData[obj.key]?.props?.children || rowData[obj.key]}
                              </span>
                            );
                          }
                        });
                      }
                    });
                    if (
                      materialDetail.vendor_sub_total &&
                      materialDetail.vendor_sub_total.length > 0
                    ) {
                      const vendorSubTotals = materialDetail.vendor_sub_total;
                      const entries = [
                        {
                          srNo: "A1",
                          keySuffix: "basic_price",
                          city: "Basic Price",
                        },
                        {
                          srNo: "B1",
                          keySuffix: "commission_charges",
                          city: "Commission Charges",
                        },
                        { srNo: "C1", keySuffix: "taxes", city: "Taxes" },
                        {
                          srNo: "D1",
                          keySuffix: "total_price",
                          city: "Total Price",
                        },
                        {
                          srNo: "E1",
                          keySuffix: "contingency",
                          city: "Contingency",
                        },
                        {
                          srNo: "F1",
                          keySuffix: "total_with_tax",
                          city: "Total With Tax",
                        },
                        {
                          srNo: "H1",
                          keySuffix: "payment_terms",
                          city: "Payment Terms",
                        },
                        {
                          srNo: "I1",
                          keySuffix: "payment_security_details",
                          city: "Payment Security Details",
                        },
                        {
                          srNo: "K1",
                          keySuffix: "commercial_ranking",
                          city: "Commercial Ranking on Total Price",
                        },
                      ];

                      let uniqueKeyCounter = 0;
                      entries.forEach((entry) => {
                        const rowData = {
                          key: `${entry.keySuffix}-${uniqueKeyCounter++}`,
                          city: entry.city,
                          srNo: entry.srNo,
                          isSummary: true,
                        };
                        if (entry.keySuffix === "commercial_ranking") {
                          const roundDetails = vendorSubTotals
                            .map((vendorDetail) => {
                              const latestRound = findLatestAvailableRound(
                                vendorDetail,
                                vendorSubTotals
                              );
                              return vendorSubTotals.find(
                                (v) =>
                                  v.vendor_name === vendorDetail.vendor_name &&
                                  v.round === latestRound
                              );
                            })
                            .filter(Boolean);
                          const commercialRankingValues = roundDetails
                            .map((vendor) => vendor.commercial_ranking)
                            .filter((value) => typeof value === "number");
                          const sortedRankingValues = [
                            ...new Set(commercialRankingValues),
                          ].sort((a, b) => a - b);
                          const lowest = sortedRankingValues[0] || null;
                          const secondLowest = sortedRankingValues[1] || null;
                          const thirdLowest = sortedRankingValues[2] || null;
                          ["r0", "r1", "r"].forEach((round) => {
                            const roundDetails = vendorSubTotals.filter(
                              (vendorDetail) => vendorDetail.round === round
                            );
                            roundDetails.forEach((vendorDetail) => {
                              const vendorKey = vendorDetail.vendor_name
                                .toLowerCase()
                                .replace(/\s+/g, "");
                              let cellContent = null;
                              // Only show for latest round, blank for others
                              const latestRound = findLatestAvailableRound(
                                vendorDetail,
                                vendorSubTotals
                              );
                              if (vendorDetail.round === latestRound) {
                                if (
                                  vendorDetail.commercial_ranking === lowest
                                ) {
                                  cellContent = (
                                    <Tooltip
                                      color={"#094E8F"}
                                      placement="top"
                                      title={
                                        <span style={{ color: "#fff" }}>
                                          Lowest Price
                                        </span>
                                      }
                                    >
                                      <span className="lowest">L1</span>
                                    </Tooltip>
                                  );
                                } else if (
                                  vendorDetail.commercial_ranking === secondLowest
                                ) {
                                  cellContent = (
                                    <Tooltip
                                      color={"#094E8F"}
                                      placement="top"
                                      title={
                                        <span style={{ color: "#fff" }}>
                                          Second Lowest Price
                                        </span>
                                      }
                                    >
                                      <span className="secondLowest">L2</span>
                                    </Tooltip>
                                  );
                                } else if (
                                  vendorDetail.commercial_ranking === thirdLowest
                                ) {
                                  cellContent = (
                                    <Tooltip
                                      color={"#094E8F"}
                                      placement="top"
                                      title={
                                        <span style={{ color: "#fff" }}>
                                          Third Lowest Price
                                        </span>
                                      }
                                    >
                                      <span className="thirdLowest">L3</span>
                                    </Tooltip>
                                  );
                                } else {
                                  cellContent = null;
                                }
                              } else {
                                cellContent = null; // Blank for non-latest rounds
                              }
                              rowData[
                                `${vendorKey}Amount${round.toUpperCase()}`
                              ] = cellContent;
                              rowData[`${vendorKey}Amount`] = cellContent;
                            });
                          });
                        } else {
                          vendorSubTotals.forEach((vendorDetail) => {
                            const vendorKey = vendorDetail.vendor_name
                              .toLowerCase()
                              .replace(/\s+/g, "");
                            const round = vendorDetail.round
                              ? vendorDetail.round.toUpperCase()
                              : "";
                            rowData[`${vendorKey}Amount${round}`] =
                              vendorDetail[entry.keySuffix] !== undefined
                                ? vendorDetail[
                                    entry.keySuffix
                                  ].toLocaleString("en-IN", {
                                    maximumFractionDigits: 0,
                                  })
                                : "N/A";
                            rowData[`${vendorKey}Amount`] =
                              vendorDetail[entry.keySuffix] !== undefined
                                ? vendorDetail[entry.keySuffix].toLocaleString(
                                    "en-IN",
                                    { maximumFractionDigits: 0 }
                                  )
                                : "N/A";
                          });
                        }
                        dataSource.push(rowData);
                      });
                      const materialRows = {};
                      vendorSubTotals.forEach((vendorDetail) => {
                        const materialTypeDetails =
                          vendorDetail.material_type_details || {};
                        const vendorName = vendorDetail.vendor_name;
                        const vendorKey = vendorName
                          .toLowerCase()
                          .replace(/\s+/g, "");
                        const round = vendorDetail.round
                          ? vendorDetail.round.toUpperCase()
                          : "";
                        let currentSrNo = "L";
                        Object.entries(materialTypeDetails).forEach(
                          ([materialType, details]) => {
                            
                            if (details) {
                              
                              const avgMT = details.average_unit_price_mt;
                              const avgBag = details.price_per_kg;
                              if (!materialRows[`${materialType}_MT`]) {
                                materialRows[`${materialType}_MT`] = {
                                  srNo: `${currentSrNo}`,
                                  key: `${materialType}_MT_row`,
                                  city: `Average Price/MT - ${materialType}`,
                                  isSummary: true,
                                };
                              }
                              if (!materialRows[`${materialType}_Bag`]) {
                                materialRows[`${materialType}_Bag`] = {
                                  srNo: `${currentSrNo}1`,
                                  key: `${materialType}_Bag_row`,
                                  city: `Average Price/KG - ${materialType}`,
                                  isSummary: true,
                                };
                              }
                              currentSrNo = String.fromCharCode(
                                currentSrNo.charCodeAt(0) + 1
                              );
                              materialRows[`${materialType}_MT`][
                                `${vendorKey}Amount${round}`
                              ] = avgMT?.toFixed(2) || "N/A";
                              materialRows[`${materialType}_Bag`][
                                `${vendorKey}Amount${round}`
                              ] = avgBag?.toFixed(2) || "N/A";
                              materialRows[`${materialType}_MT`][
                                `${vendorKey}Amount`
                              ] = avgMT?.toFixed(2) || "N/A";
                              materialRows[`${materialType}_Bag`][
                                `${vendorKey}Amount`
                              ] = avgBag?.toFixed(2) || "N/A";
                            }
                          }
                        );
                      });
                      Object.values(materialRows).forEach((row) =>
                        dataSource.push(row)
                      );
                    }
                    if (
                      materialDetail.vendor_summary &&
                      materialDetail.vendor_summary.length > 0
                    ) {
                      const vendorSummaryTotals = materialDetail.vendor_summary;
                      let uniqueSummaryKeyCounter = 1;
                      const summaryEntries = [
                        {
                          keySuffix: "supply_site_wise",
                          siteName: "Supply - Site Wise",
                        },
                        {
                          keySuffix: "freight_site_wise",
                          siteName: "Freight - Site Wise",
                        },
                        {
                          keySuffix: "sub_total",
                          siteName:
                            "Sub Total (Site Wise) (Supply + Freight)",
                        },
                        {
                          keySuffix: "supply_site_order_value",
                          siteName:
                            "Supply as a % of respective site order value",
                        },
                        {
                          keySuffix: "freight_site_order_value",
                          siteName:
                            "Freight as a % of respective site order value",
                        },
                      ];
                      summaryEntries.forEach((entry) => {
                        const rowData = {
                          srNo: `${uniqueSummaryKeyCounter++}`,
                          title: entry.siteName,
                          uom: entry.keySuffix,
                        };
                        vendorSummaryTotals.forEach((vendorDetail) => {
                          const vendorKey = vendorDetail.vendor_name
                            .toLowerCase()
                            .replace(/\s+/g, "");
                          rowData[`${vendorKey}Amount`] =
                            entry.keySuffix === "supply_site_order_value" ||
                            entry.keySuffix === "freight_site_order_value"
                              ? `${vendorDetail[entry.keySuffix]?.toFixed(2)}`
                              : `${vendorDetail[
                                  entry.keySuffix
                                ]?.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                })}`;
                        });
                        dataSource.push(rowData);
                      });
                    }
                  }
                );
              }
            );
          }
        );
        let summaryDataSource = [];
        response1.data.data.comparative_details_by_rfq_site_wise.forEach(
          (cityDetail) => {
            cityDetail.rfq_site_wise_details.forEach((siteDetail) => {
              siteDetail.rfq_material_wise_details.forEach(
                (materialDetail) => {
                  if (
                    materialDetail.vendor_summary &&
                    materialDetail.vendor_summary.length !== 0
                  ) {
                    const vendorSummaryTotals = materialDetail.vendor_summary;
                    if (vendorSummaryTotals.length > 0) {
                      let uniqueSummaryKeyCounter = 1;
                      const summaryEntries = [
                        {
                          keySuffix: "supply_site_wise",
                          siteName: "Supply - Site Wise",
                        },
                        {
                          keySuffix: "freight_site_wise",
                          siteName: "Freight - Site Wise",
                        },
                        {
                          keySuffix: "sub_total",
                          siteName: "Sub Total (Site Wise)",
                        },
                        {
                          keySuffix: "supply_site_order_value",
                          siteName:
                            "Supply as a % of respective site order value",
                        },
                        {
                          keySuffix: "freight_site_order_value",
                          siteName:
                            "Freight as a % of respective site order value",
                        },
                      ];
                      summaryEntries.forEach((entry) => {
                        const rowData = {
                          srNo: `${uniqueSummaryKeyCounter++}`,
                          title: entry.siteName,
                          uom: entry.keySuffix,
                        };
                        vendorSummaryTotals.forEach((vendorDetail) => {
                          const vendorKey = vendorDetail.vendor_name
                            .toLowerCase()
                            .replace(/\s+/g, "");
                          rowData[`${vendorKey}Amount`] =
                            entry.keySuffix === "supply_site_order_value" ||
                            entry.keySuffix === "freight_site_order_value"
                              ? `${vendorDetail[entry.keySuffix]?.toFixed(2)}`
                              : `${vendorDetail[
                                  entry.keySuffix
                                ]?.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                })}`;
                        });
                        summaryDataSource.push(rowData);
                      });
                    }
                  }
                }
              );
            });
          }
        );
        const summaryTitlesToRemove = [
          "Supply - Site Wise",
          "Freight - Site Wise",
          "Sub Total (Site Wise)",
          "Sub Total (Site Wise) (Supply + Freight)",
          "Supply as a % of respective site order value",
          "Freight as a % of respective site order value",
          "sub_total",
        ];
        dataSource = dataSource.filter(
          (row) =>
            !summaryTitlesToRemove.includes(row.city) &&
            !summaryTitlesToRemove.includes(row.title)
        );
        setDataSource(dataSource);
        setSummaryDataSource(summaryDataSource);
        const vendorArr = Array.from(uniqueVendors);
        setVendors(vendorArr);
        setVendorBidDates(vendorBidDatesTemp);
        const vendorSummaryColumns = (
          Array.isArray(vendorArr) ? vendorArr : []
        ).map((vendorName) => {
          let round = "";

          const vendorKey = vendorName.toLowerCase().replace(/\s+/g, "");
          const bidDates = vendorBidDatesTemp[vendorKey] || {};

          const hasFinalBid =
            bidDates.finalBidDate && bidDates.finalBidDate !== "N/A";
          const hasRevisedBid =
            bidDates.revisedBidDate && bidDates.revisedBidDate !== "N/A";
          const hasInitialBid =
            bidDates.initialBidDate && bidDates.initialBidDate !== "N/A";

          if (hasFinalBid) {
            round = "R - Final";
          } else if (hasRevisedBid) {
            round = "R1 - Revised";
          } else if (hasInitialBid) {
            round = "R0 - Initial";
          }

          return {
            title: vendorName,
            children: [
              {
                title: round || "N/A",
                align: "center",
                children: [
                  {
                    title: "Basic Amount",
                    dataIndex: `${vendorKey}Amount`,
                    key: `${vendorKey}Amount`,
                    align: "right",
                    render: (value) => value || "N/A",
                  },
                ],
              },
            ],
          };
        });
        setSummaryColumn(vendorSummaryColumns);

        // --- BEGIN: Add city and material filter options (from ComparativeSiteWise.js) ---
        // Set city filter options
        const cities =
          response1.data.data.comparative_details_by_rfq_site_wise.flatMap(
            (cityItem, cityIndex) => ({
              name: cityItem.rfq_city_name,
              id: cityIndex,
            })
          );
        // setSiteName(cities);

        // Set material filter options
        const materialTypes =
          response1.data.data.comparative_details_by_rfq_site_wise.flatMap(
            (cityItem) =>
              cityItem.rfq_site_wise_details.flatMap((siteItem) =>
                siteItem.rfq_material_wise_details.map((materialItem) => ({
                  id: materialItem.rfq_material_type_id,
                  name: materialItem.rfq_material_type_name,
                }))
              )
            );
          const uniqueMaterialTypes = materialTypes.filter(
            (material, index, self) =>
              index ===
              self.findIndex(
                (m) => m.id === material.id && m.name === material.name
              )
          );
        } else {
          ErrorNotificationMsg(t("Error fetching site details"));
        }
        setapiLoading(false);
      } catch (error) {
        console.error("Failed to fetch data:", error);
        setapiLoading(false);
      }
    };
  

  const handleSiteNameSelectChange = async (value) => {
    const updatedState1 = { ...state, city_names: value };
    setState(updatedState1);
  };

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
    } else {
      updateState();
    }
  }, [state]);

  const handleMaterialSelectChange = async (value) => {
    const updatedState2 = { ...state, material_type_names: value };
    setState(updatedState2);
  };

  const columns3 = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      key: "srNo",
    },
    {
      title: "",
      dataIndex: "title",
      key: "title",
      render: (text, record, index) => {
        return text?.toLocaleString("en-IN", { maximumFractionDigits: 0 });
      },
    },
    ...summaryColumn,
  ];

  const downloadExcel = async () => {
    const worksheet = XLSX.utils.json_to_sheet(dataSource1);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Table Data");
    XLSX.writeFile(workbook, `comparatives-rfq_city_wise${+new Date()}.xlsx`);
  };

  const exportToExcel = async () => {
    const canvas = await html2canvas(tableRef.current, { scale: 2 });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const headline = "Comparatives - City Wise";
    pdf.setFontSize(18);
    const textWidth = pdf.getTextWidth(headline);
    const centerX = (pageWidth - textWidth) / 2;
    const centerY = pageHeight / 2 - 20;

    pdf.text(headline, centerX, 20);
    const imgWidth = 190;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 10, 30, imgWidth, imgHeight);
    pdf.save(`Comparatives-${rfqNumber}`);
  };

  const exportToPdf = () => {
    const pdf = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });

    const pageWidth = pdf.internal.pageSize.getWidth();

    const headline = "Comparatives - City Wise";
    pdf.setFontSize(12);
    const textWidth = pdf.getTextWidth(headline);
    pdf.text(headline, (pageWidth - textWidth) / 2, 15);

    if (!tableRef.current) return;

    let headers = [];
    const headerCells = tableRef.current.querySelectorAll("thead tr th");

    let staticHeaders = ["Sr. No.", "City", "Site", "Item", "Quantity", "UoM"];
    headers.push(...staticHeaders);

    let vendorHeaders = [];
    headerCells.forEach((cell, index) => {
      let text = cell.innerText.trim();
      if (index >= staticHeaders.length) {
        text = text.replace(/\d{2}-\d{2}-\d{2}/g, "").trim();
        if (!text.includes("Unit Rate") && !text.includes("Basic Amount")) {
          vendorHeaders.push(`${text} - Unit Rate`);
          vendorHeaders.push(`${text} - Basic Amount`);
        }
      }
    });

    headers.push(...vendorHeaders);
    const data = [];
    const rows = tableRef.current.querySelectorAll("tbody tr");

    for (let i = 1; i < rows.length; i++) {
      const row = rows[i];
      const rowData = [];
      const cells = row.querySelectorAll("td");

      cells.forEach((cell, index) => {
        if (index < staticHeaders.length) {
          rowData.push(cell.innerText.trim());
        }
      });

      let vendorData = [];
      for (let i = staticHeaders.length; i < cells.length; i += 2) {
        const unitRate = cells[i]?.innerText.trim() || "-";
        const basicAmount = cells[i + 1]?.innerText.trim() || "-";
        vendorData.push(unitRate, basicAmount);
      }

      rowData.push(...vendorData);
      data.push(rowData);
    }

    pdf.autoTable({
      head: [headers],
      body: data,
      startY: 20,
      styles: { fontSize: 8, cellPadding: 3, overflow: "linebreak" },
      theme: "grid",
      precision: 100,
      headStyles: {
        fillColor: [0, 122, 255],
        textColor: 255,
        fontStyle: "bold",
      },
      alternateRowStyles: { fillColor: [240, 240, 240] },
      margin: { top: 30, left: 10, right: 10 },
      columnStyles: {
        0: { cellWidth: 15 },
        1: { cellWidth: 40 },
        2: { cellWidth: 40 },
        3: { cellWidth: 30 },
        4: { cellWidth: 25 },
        5: { cellWidth: 25 },
        ...vendorHeaders.reduce((cols, header, index) => {
          cols[staticHeaders.length + index] = { cellWidth: 25 };
          return cols;
        }, {}),
      },
      didDrawPage: (data) => {
        pdf.setFontSize(10);
        pdf.setTextColor(0);
      },
    });

    pdf.save(`comparatives_city_wise_${Date.now()}.pdf`);
  };

  const menu = (
    <Menu className="downloadmenu">
      <Menu.ItemGroup
        key="pdf"
        title={
          <span style={{ fontWeight: "bold" }}>
            <img src={PDF} alt="PDF Icon" /> Download PDF
          </span>
        }
      >
        <Menu.Item key="pdf1" onClick={exportToExcel}>
          1.1 Download as per current view
        </Menu.Item>
      </Menu.ItemGroup>

      <Menu.ItemGroup
        key="excel"
        title={
          <span style={{ fontWeight: "bold" }}>
            <img src={Excel} alt="PDF Icon" />
            Download Excel
          </span>
        }
      >
        <DownloadTableExcel
          filename={`Comparative City Wise Statement-${rfqNumber}`}
          sheet="users"
          currentTableRef={tableRef.current}
        >
          <Menu.Item key="excel2">2.1. Download as per current view</Menu.Item>
        </DownloadTableExcel>

        <Menu.Item key="excel2">
          <DownloadTableExcel
            filename={`Comparative City Wise Statement-${rfqNumber}`}
            sheet="users"
            currentTableRef={hiddenTableRef.current}
          >
            2.2. Download all offers (BIDs)
          </DownloadTableExcel>
        </Menu.Item>
      </Menu.ItemGroup>
    </Menu>
  );

  const handleExcelDownload = async () => {
    const endpoint = `comparative-rfq/${id}/comparative-excel-material-download/`;
    const fileType = "csv";
    try {
      await getRequest(endpoint)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "text/csv",
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `comparatives-rfq_${+new Date()}.${fileType}`;
          link.click();
        })
        .catch((error) => {
          //ErrorNotificationMsg(t(`err_${fileType}_download`));
        });
    } catch (error) {
      //setBtnloading(false);
      //ErrorNotificationMsg(error);
    }
  };

  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      key: "srNo",
      width: 40,
      align: "center",
      render: (text, record) => {
        if (record.isSummary) {
          let color, label;
          if (summaryRowMeta[record.srNo]) {
            color = summaryRowMeta[record.srNo].color;
            label = summaryRowMeta[record.srNo].label;
          } else {
            color = getDistinctDynamicColor(record.srNo);
            label = record.srNo;
          }
          return (
            <span
              style={{
                backgroundColor: color,
                color: "#333",
                borderRadius: 4,
                padding: "2px 8px",
                fontWeight: "bold",
                minWidth: 32,
                display: "inline-block",
                textAlign: "center",
              }}
            >
              {label}
            </span>
          );
        }
        // For normal rows, show the running number or text
        return text;
      },
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: 30,
      render: (text, record, index) => {
        const a1Index = dataSource1.findIndex(
          (row) => row && row.srNo === "A1"
        );
        const nextRow = dataSource1[index + 1];
        if (a1Index !== -1 && index >= a1Index) {
          return {
            children: getCustomText(text, record),
            props: { colSpan: 2 },
          };
        } else {
          return {
            children: getCustomText(text, record),
            props: { colSpan: 1 },
          };
        }
      },
    },
    {
      title: "Site",
      dataIndex: "site",
      key: "site",
      width: 20,
    },
        {
      title: "Sub Category",
      dataIndex: "subCategory",
      key: "subCategory",
      width: "80px",
      render: (text, record, index) => {
        const nextRow = dataSource1[index + 1];

        const a1Index = dataSource1.findIndex((row) => row.srNo === "A1");

        // if (index >= a1Index) {
        //   return {
        //     children: text,
        //     props: {
        //       colSpan: 0,
        //     },
        //   };
        // } else {
        return text;
        // }
      },
    },
    {
      title: "Grade & Quality",
      dataIndex: "materialType",
      key: "materialType",
      width: 120,
      render: (text, record, index) => {
        const nextRow = dataSource1[index + 1];

        const a1Index = dataSource1.findIndex((row) => row.srNo === "A1");

        if (index >= a1Index) {
          return {
            children: text,
            props: {
              colSpan: 0,
            },
          };
        } else {
          return text;
        }
      },
    },
    showGST && {
      title: (
        <>
          <p>GST</p>
          <p>(%)</p>
        </>
      ),
      dataIndex: "gst_rate",
      key: "gst_rate",
      width: 40,
      align: "center",
    },
    {
      title: "UoM.",
      dataIndex: "uom",
      key: "uom",
      align: "center",
      // width: "auto",
      width: "50px",

      render: (text, record) => (text === "Cubic Meter" ? "Cu. Mtr." : text),
    },
    {
      title: "Diameter",
      dataIndex: "diameter",
      key: "diameter",
      align: "center",
      width: 80,
    },

    {
      title: "Qty.",
      dataIndex: "qty",
      key: "qty",
      align: "center",
      // width: "auto",
      width: "50px",

      render: (text, record, index) =>
        text?.toLocaleString("en-IN", { maximumFractionDigits: 0 }),
    },

    showLPP && {
      title: "LPP (Last Purchase Price)",
      children: [
        {
          title: "Last order detail",
          children: [
            {
              title: "PO & Date",
              dataIndex: "poDate",
              key: "poDate",
              width: 90,
              render: (text, record) => {
                if (!text) return "";
                const [poNumber, date] = text.split(" - ");
                return (
                  <>
                    <p style={{ fontSize: "12px" }}>{poNumber}</p>
                    <p style={{ fontSize: "12px" }}>{date}</p>
                  </>
                );
              },
            },
            {
              title: "Vendor Name",
              dataIndex: "vendorName",
              key: "vendorName",
              width: 90,
            },
            {
              title: "Unit Price",
              dataIndex: "unitPrice",
              key: "unitPrice",
              width: 80,
              align: "right",
              render: (value, record) => {
                if (record.isSummary) {
                  return "";
                }
                return value;
              },
            },
          ],
        },
        {
          title: (
            <Tooltip
              color="#094E8F"
              placement="top"
              title="Last 30 Days Avg. Price"
            >
              30DAP{" "}
              <InfoCircleOutlined
                style={{ color: "#094E8F", marginLeft: "3px" }}
              />
            </Tooltip>
          ),
          width: 100,
          align: "right",
          children: [
            {
              title: "",
              dataIndex: "avgPrice",
              key: "avgPrice",
              width: 100,
              align: "right",
            },
          ],
        },
      ],
    },
    {
      title: (
        <Tooltip color="#094E8F" placement="top" title="Item wise L1">
          IWL1{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      children: [
        {
          title: "",
          dataIndex: "itemWiseL1",
          key: "itemWiseL1",
          width: 100,
          align: "right",
          render: (text, record) => <strong>{text}</strong>,
        },
      ],
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title="Last 30 Days CityWise Avg. Price on Smart Buyer"
        >
          30DAP {""}{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      width: 80,
      children: [
        {
          title: "",
          dataIndex: "cityWise",
          width: 120,
          key: "cityWise",
          align: "right",
        },
      ],
    },
    ...venColumn,
  ].filter(Boolean);

  

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Comparatives - City Wise</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">RFQ History</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Comparatives - City Wise</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <h5 className="rfq-number new">
            RFQ Number :{" "}
            <span style={{ marginRight: "20px" }}>{rfqNumber}</span>
            Buyer : <span>{buyerName}</span>
          </h5>
          <div className="btnwrp2" style={{ alignItems: "center" }}>
            <h5 className="rfq-number new">Amount in INR</h5>
            <Dropdown overlay={menu} trigger={["hover"]} placement="bottom">
              <Button
                className="SaveGradiantBtn"
                type="primary"
                htmlType="PDF"
                label="PDF"
                icon={<img src={Downloadpd} alt="PDF Icon" />}
              >
                Download
              </Button>
            </Dropdown>
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              label="View Material Wise"
              onClick={() =>
                navigate(
                  `/request-for-quotation/material-wise-comparatives-by-diameter/${id}`
                )
              }
            />
          </div>
        </div>
      </div>
<div className="stepscontentwrap">
        <div className="stepsContent">
      <section className="grid-sec mt-5">
        <div className="PR-body" style={{padding:'0'}}>
          <div
            className="rgq-num-wrap"
            style={{ flexWrap: "wrap", alignItems: "center" }}
          >
            <div className="bidleftfilters">
              <Checkbox checked={showR0} onChange={handleCheckboxhideR1}>
                Show Initial BID Price - R0
              </Checkbox>
              <Checkbox checked={showR1} onChange={handleCheckboxhideR}>
                Show Revised BID Price - R1
              </Checkbox>
              <Checkbox checked={showLPP} onChange={handleCheckboxhideLPP}>
                Show Last Purchase Price
              </Checkbox>
              <Checkbox checked={showGST} onChange={handleCheckboxhideGST}>
                Show GST %
              </Checkbox>
            </div>
            <div className="bidlRightfilters" style={{ flexWrap: "nowrap" }}>
              <label>City Wise Filter</label>
              <Form.Item name="site_name" label="">
                <Select
                  showArrow
                  mode="multiple"
                  showSearch
                  allowClear
                  placeholder="Select City"
                  optionFilterProp="children"
                  onChange={handleSiteNameSelectChange}
                  value={state.city_names}
                  style={{ width: "160px" }}
                >
                  {siteName.map((item) => (
                    <Option key={item.id} value={item.name}>
                      {item.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <label>Material Wise Filter</label>
              <Form.Item name="material_type" label="">
                <Select
                  showArrow
                  mode="multiple"
                  showSearch
                  allowClear
                  placeholder="Select Material"
                  optionFilterProp="children"
                  onChange={handleMaterialSelectChange}
                  value={state.material_type_names}
                  style={{ width: "200px" }}
                >
                  {materialName.map((material) => (
                    <Option key={material.id} value={material.name}>
                      {material.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>

          <Spin spinning={apiLoading}>
            <div ref={tableRef}>
              <Table
                ref={tableRef}
                dataSource={dataSource1}
                bordered
                scroll={{ x: "auto" }}
                columns={columns}
                className="comparativecustomtbl"
                pagination={false}
              />
            </div>
          </Spin>
          <div className="footerTable">
            <Table
              columns={columns3}
              dataSource={summaryDataSource}
              pagination={false}
              bordered
            />
          </div>
        
        </div>
        <div ref={hiddenTableRef} style={{ display: "none" }}>
          <Table
            ref={hiddenTableRef}
            dataSource={dataSource1}
            bordered
            scroll={{ x: "auto" }}
            columns={hiddencolumns1}
            className="comparativecustomtbl"
            pagination={false}
            // sticky
          />
        </div>
      </section>
      </div>
        <div className="FormFooter bidftr" style={{padding:'16px  ', margin:'0'}}>
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              label="Price Comparative Review"
              onClick={() => {
                categoryType
                  ? navigate(
                      `/request-for-quotation/summarypricecomparatives/${id}`
                    )
                  : navigate(
                      `/request-for-quotation/summarypricecomparatives-by-diameter/${id}`
                    );
              }}
            />
          </div>
      </div>
    </>
  );
};

export default ComparativeSiteDiameterWise;
